<template>
	<Select v-model="selectedEnergyLabel">
		<SelectTrigger class="bg-white">
			<SelectValue placeholder="Kies een energielabel">
				<EuEnergyLabel
					v-if="selectedEnergyLabel"
					class="min-w-[100px]"
					align="start"
					:energy-label="selectedEnergyLabel"
				/>
			</SelectValue>
		</SelectTrigger>
		<SelectContent>
			<SelectGroup>
				<SelectItem :value="null"> Kies een energielabel... </SelectItem>
				<SelectItem
					v-for="label in energielabels"
					:key="label.value"
					:value="label.value"
				>
					<EuEnergyLabel
						class="min-w-[100px]"
						align="start"
						:energy-label="label.value"
					/>
				</SelectItem>
			</SelectGroup>
		</SelectContent>
	</Select>
</template>

<script setup lang="ts">
import type { EnergieLabel } from "@loanlink-nl/model-app";
import type { SelectOption } from "@/models/SelectOption";

const energielabels = [
	{
		value: "14 A++++ (EP garantie)" as const,
		label: "A++++ (EP garantie)",
	},
	{ value: "11 A++++" as const, label: "A++++" },
	{ value: "10 A+++" as const, label: "A+++" },
	{ value: "01 A++" as const, label: "A++" },
	{ value: "02 A+" as const, label: "A+" },
	{ value: "03 A" as const, label: "A" },
	{ value: "04 B" as const, label: "B" },
	{ value: "05 C" as const, label: "C" },
	{ value: "06 D" as const, label: "D" },
	{ value: "07 E" as const, label: "E" },
	{ value: "08 F" as const, label: "F" },
	{ value: "09 G" as const, label: "G" },
] satisfies SelectOption[];

const selectedEnergyLabel = defineModel<EnergieLabel>();
</script>
